import { Check } from 'lucide-react';
import type { ReactElement } from 'react';

import { cn } from '@/components/ui/cn';

import { stepperStages } from '../stepper-presentation';
import type { TrainingStage } from '../training-stage';
import type { DocumentStatus, FlowHistoryItem } from '../types';
import { formatDateTime } from '@/lib/time';

interface Props {
  currentStatus: DocumentStatus;
  history: FlowHistoryItem[];
  /** G4: etapa de capacitación (null mientras carga o si no se pudo leer). */
  training?: TrainingStage | null;
}

/** Barra de etapas del ciclo (spec §4.3; G4: cinco etapas con la capacitación). El
 *  estado done/now/pending se deriva del flujo y de la capacitación; la etapa actual
 *  lleva aria-current y una capacitación vencida lo dice en texto, no solo en color. */
export function FlowStepper({ currentStatus, history, training = null }: Props): ReactElement {
  const stages = stepperStages(currentStatus, history, training);
  return (
    <div className="card rise d1">
      <div className="ch">
        <h3>Flujo de aprobación</h3>
      </div>
      <ol className="cb steps" aria-label="Etapas del ciclo documental">
        {stages.map((stage, i) => (
          <li
            key={stage.key}
            className={cn('step', stage.state === 'done' && 'done', stage.state === 'now' && 'now')}
            aria-current={stage.state === 'now' ? 'step' : undefined}
          >
            <div className="ic" aria-hidden="true">
              {stage.state === 'done' ? <Check size={14} /> : i + 1}
            </div>
            <div>
              <div className="t">
                {stage.label}
                {stage.overdue ? (
                  <>
                    {' '}
                    <span className="badge b-red">Vencida</span>
                  </>
                ) : null}
              </div>
              <div className="w">
                {stage.at !== null
                  ? formatDateTime(stage.at)
                  : stage.state === 'now'
                    ? 'En curso'
                    : 'Pendiente'}
              </div>
              {stage.note !== null ? <div className="w">{stage.note}</div> : null}
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
